import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface DirectorTeamStats {
  todayAttendance: {
    present: number;
    absent: number;
    late: number;
    onLeave: number;
    total: number;
    presentPercentage: number;
  };
  yesterdayAttendance: {
    present: number;
    absent: number;
    late: number;
    presentPercentage: number;
  };
  weeklyAverage: {
    avgPresent: number;
    avgPercentage: number;
  };
  lateToday: number;
  onTimeToday: number;
}

export interface DirectorTeamStatsResponse {
  success: boolean;
  data: DirectorTeamStats;
  message?: string;
}

const getDirectorTeamStats = async (): Promise<DirectorTeamStatsResponse> => {
  const { data } = await customAxios.get<DirectorTeamStatsResponse>(
    `/attendance/director/team/stats`
  );
  return data;
};

export const useGetDirectorTeamStats = () =>
  useQuery<DirectorTeamStatsResponse, AxiosError>(
    ["director-team-stats"],
    () => getDirectorTeamStats(),
    {
      staleTime: 60000, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
